angular.
module("dx.webapp.masterTools").
controller("DxImportTeacherDataController", function ImportTeacherDataController(
	$location,

	DX_UPLOAD_STATE,
	dxApi,

	NodeRepository,
	Node,
	DX_URLS
) {
	"use strict";

	var self = this;

	self.DX_UPLOAD_STATE = DX_UPLOAD_STATE;
	self.dxApi = dxApi;
	self.Urls = DX_URLS;

	self.loading = true;
	self.error = null;
	self.nodes = [];
	self.specificUser = false;
	self.userId = null;
	self.organizationId = null;
	self.jobs = [];

	var searchObject = $location.search();

	if (searchObject.userId) {
		self.userId = parseInt(searchObject.userId, 10);
		self.specificUser = true;
	}

	if (searchObject.organizationId) {
		self.organizationId = parseInt(searchObject.organizationId, 10);
	}

	self.onFileUploaded = function onFileUploaded(item, response) {
		if (item.isError && response && response.message) {
			item.errorMessage = response.message;
		} else if (!item.isError && response) {
			self.jobs.push(response);
		}
	};

	self.onCompleteAll = function onCompleteAll() {
		self.isDone = true;
	};

	function onNodeListSuccess(response) {
		self.loading = false;

		for (var i = 0; i < response.nodes.length; i++) {
			var node = new Node(response.nodes[i]);
			self.nodes.push(node);
		}
	}

	function onNodeListFail(response) {
		self.loading = false;
		self.error = response.data;
	}

	NodeRepository.list().then(onNodeListSuccess, onNodeListFail);
});
